export default __webpack_public_path__ + "static/hiscocase1-28d0b72d1228b943af5f762a5e8b28ac.png";